import { cloneDeep } from 'lodash';
import { clearLoginError } from './login_error';
const TOGGLE_CART_MODAL 				= 'TOGGLE_CART_MODAL';
const TOGGLE_MINI_CART_MODAL 			= 'TOGGLE_MINI_CART_MODAL';
const TOGGLE_CREDIT_BOX_MODAL 			= 'TOGGLE_CREDIT_BOX_MODAL';
const TOGGLE_CUSTOMER_MODAL 			= 'TOGGLE_CUSTOMER_MODAL';
const TOGGLE_FORGOT_PASSWORD_MODAL 		= 'TOGGLE_FORGOT_PASSWORD_MODAL';
const TOGGLE_LOGIN_MODAL 				= 'TOGGLE_LOGIN_MODAL';
const TOGGLE_ORDER_SUCCESS_MODAL 		= 'TOGGLE_ORDER_SUCCESS_MODAL';
const TOGGLE_PRICE_GUIDE_MODAL 			= 'TOGGLE_PRICE_GUIDE_MODAL';
const TOGGLE_UPGRADE_CATALOG_MODAL 		= 'TOGGLE_UPGRADE_CATALOG_MODAL';
const TOGGLE_UPGRADE_FLOW_MODAL 		= 'TOGGLE_UPGRADE_FLOW_MODAL';
const TOGGLE_EMAIL_CAPTURE_MODAL 		= 'TOGGLE_EMAIL_CAPTURE_MODAL';
const TOGGLE_WISHLIST_MODAL 			= 'TOGGLE_WISHLIST_MODAL';
const TOGGLE_DECLINE_MODAL 				= 'TOGGLE_DECLINE_MODAL';
const TOGGLE_FEATURED_SELECTION_MODAL 	= 'TOGGLE_FEATURED_SELECTION_MODAL';
const TOGGLE_CLOSE_MODAL				= 'TOGGLE_CLOSE_MODAL';
const CLOSE_MODAL 						= '';
const actionTypeToModal = {
	TOGGLE_CART_MODAL 				: 'cart',
	TOGGLE_MINI_CART_MODAL 			: 'miniCart',
	TOGGLE_CREDIT_BOX_MODAL 		: 'creditBox',
	TOGGLE_CUSTOMER_MODAL 			: 'customer',
	TOGGLE_FORGOT_PASSWORD_MODAL  	: 'forgotPassword',
	TOGGLE_LOGIN_MODAL 				: 'login',
	TOGGLE_ORDER_SUCCESS_MODAL 		: 'orderSuccess',
	TOGGLE_PRICE_GUIDE_MODAL 		: 'priceGuide',
	TOGGLE_UPGRADE_CATALOG_MODAL 	: 'upgradeCatalog',
	TOGGLE_UPGRADE_FLOW_MODAL 	  	: 'upgradeFlow',
	TOGGLE_EMAIL_CAPTURE_MODAL 		: 'emailCapture',
	TOGGLE_WISHLIST_MODAL 			: 'wishlist',
	TOGGLE_DECLINE_MODAL			: 'decline',
	TOGGLE_FEATURED_SELECTION_MODAL	: 'featuredSelection',
	TOGGLE_CLOSE_MODAL 				: ''
};

const initialState = CLOSE_MODAL;

export default function reducer(state = cloneDeep(initialState), action) {
	if (state === actionTypeToModal[action.type]) action.type = TOGGLE_CLOSE_MODAL;
	switch (action.type) {
		case TOGGLE_CART_MODAL:
			return actionTypeToModal[TOGGLE_CART_MODAL];
		case TOGGLE_MINI_CART_MODAL:
			return actionTypeToModal[TOGGLE_MINI_CART_MODAL];
		case TOGGLE_CREDIT_BOX_MODAL:
			return actionTypeToModal[TOGGLE_CREDIT_BOX_MODAL];
		case TOGGLE_CUSTOMER_MODAL:
			return actionTypeToModal[TOGGLE_CUSTOMER_MODAL];
		case TOGGLE_EMAIL_CAPTURE_MODAL:
			return actionTypeToModal[TOGGLE_EMAIL_CAPTURE_MODAL];
		case TOGGLE_FORGOT_PASSWORD_MODAL:
			return actionTypeToModal[TOGGLE_FORGOT_PASSWORD_MODAL];
		case TOGGLE_LOGIN_MODAL:
			return actionTypeToModal[TOGGLE_LOGIN_MODAL];
		case TOGGLE_ORDER_SUCCESS_MODAL:
			return actionTypeToModal[TOGGLE_ORDER_SUCCESS_MODAL];
		case TOGGLE_PRICE_GUIDE_MODAL:
			return actionTypeToModal[TOGGLE_PRICE_GUIDE_MODAL];
		case TOGGLE_UPGRADE_CATALOG_MODAL:
			return actionTypeToModal[TOGGLE_UPGRADE_CATALOG_MODAL];
		case TOGGLE_UPGRADE_FLOW_MODAL:
			return actionTypeToModal[TOGGLE_UPGRADE_FLOW_MODAL];
		case TOGGLE_WISHLIST_MODAL:
			return actionTypeToModal[TOGGLE_WISHLIST_MODAL];
		case TOGGLE_DECLINE_MODAL:
			return actionTypeToModal[TOGGLE_DECLINE_MODAL];
		case TOGGLE_FEATURED_SELECTION_MODAL:
			return actionTypeToModal[TOGGLE_FEATURED_SELECTION_MODAL];
		case TOGGLE_CLOSE_MODAL:
			return actionTypeToModal[TOGGLE_CLOSE_MODAL];
		default:
			return state;
	}
}

function toggleModal( type ){
	return [
		{ type: type },
		clearLoginError()
	];
}

export function openCartModal(){
	return toggleModal( TOGGLE_CART_MODAL );
};

export function openMiniCartModal(){
	return toggleModal( TOGGLE_MINI_CART_MODAL );
};

export function openCreditBoxModal(){
	return toggleModal( TOGGLE_CREDIT_BOX_MODAL);
};

export function openCustomerModal(){
	return toggleModal( TOGGLE_CUSTOMER_MODAL );
};

export function openEmailCaptureModal(){
	return toggleModal( TOGGLE_EMAIL_CAPTURE_MODAL);
};

export function openForgotPasswordModal(){
	return toggleModal( TOGGLE_FORGOT_PASSWORD_MODAL );
};

export function openLoginModal(){
	return toggleModal( TOGGLE_LOGIN_MODAL );
};

export function openOrderSuccessModal(){
	return toggleModal( TOGGLE_ORDER_SUCCESS_MODAL );
};

export function openPriceGuideModal(){
	return toggleModal( TOGGLE_PRICE_GUIDE_MODAL );
};

export function openUpgradeCatalogModal(){
	return toggleModal( TOGGLE_UPGRADE_CATALOG_MODAL);
};

export function openUpgradeFlowModal(){
	return toggleModal( TOGGLE_UPGRADE_FLOW_MODAL );
}

export function openWishlistModal(){
	return toggleModal( TOGGLE_WISHLIST_MODAL );
};

export function openDeclineModal(){
	return toggleModal( TOGGLE_DECLINE_MODAL );
}

export function openFeaturedSelectionsModal(){
	return toggleModal( TOGGLE_FEATURED_SELECTION_MODAL );
};

export function closeModal(){
	return toggleModal( TOGGLE_CLOSE_MODAL );
};


// WEBPACK FOOTER //
// ./src/modules/active_modal.js